import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

import {
  isGuestMode,
  isUserLogged,
  getLogoutRedirectPath,
} from '#/redux/modules/user/selectors';

import { actions as userActions } from '#/redux/modules/user/actions';
import { authFlowRoutes } from '#/utils/routes';

const LogoutRedirect = () => {
  const isGuestModeEnabled = useSelector(isGuestMode);
  const isUserLoggedIn = useSelector(isUserLogged);
  const logoutRedirectPath = useSelector(getLogoutRedirectPath);
  const dispatch = useDispatch();

  const redirect = useMemo(() => {
    if (isUserLoggedIn || isGuestModeEnabled) {
      return null;
    }

    if (logoutRedirectPath) {
      setTimeout(() => {
        dispatch(userActions.clearLogoutRedirectPath());
      }, 1000);
      return <Redirect push to={logoutRedirectPath} />;
    }

    return <Redirect to={authFlowRoutes.GUEST_PROFILE} />;
  }, [isUserLoggedIn, logoutRedirectPath, isGuestModeEnabled]);

  return <>{redirect}</>;
};

export default LogoutRedirect;
